module.exports = __webpack_public_path__ + "static/media/teeth.41012dac.png";